import React from 'react';
import $ from "jquery";
import Select from 'react-select';

import { sendRequest } from '../global.js';

export default class SelectInput extends React.Component {

  constructor(props) {
    super(props);
    var object = this.props.object;
    var properties = this.props.properties;
    let displayKey = properties.displayField || "name";
    if (properties.type === "select") {
      if (object && object.id) {
        object.label = object[displayKey];
      } else if (typeof object !== "string") {
          object = null;
      }
    }
    if (properties.type === "multi") {
      let items = [];
      for (let i = 0; i < object.length; i++) {
        if (object[i].id) {
          object[i].label = object[i][displayKey];
          items.push(object[i]);
        }
      }
      object = items;
    }
    this.state = {
      object: object,
      properties: this.props.properties,
    };
  }

  componentDidMount = () => {
    this.getOptions();
  }

  handleSelectInputChange = (e) => {
    var properties = this.state.properties;
    if (properties.minSearch) {
      this.getOptions(e);
    }
  }

  getOptions = (input) => {
    var properties = this.state.properties;
    let displayKey = properties.displayField || "name";
    var method = properties.request;
    // Load select options and autocomplete if edit is enabled 
    if (!method || properties.hostProperty) {
      return;
    }
    if (method.match(/:id/)) {
      if (this.props.parentId) {
        method = method.replace(":id", this.props.parentId);
      } else {
        return;
      }
    }
    var data = {scope: "headers"};
    if (properties.minSearch) {
      if (!input || input.length < properties.minSearch) {
        if (this.state.options && this.state.options.length > 0) {
          this.setState({options: []});
        }
        return;
      }
      data[displayKey] = input;
    }        
    sendRequest({
      method: method,
      type: "GET",
      data: data,
      success: (data) => {
        let options = [];
        for (let i = 0; i < data.length; i++) {
          if (typeof data[i] === "string") {
              options.push({value: data[i], label: data[i]});
          } else {
              data[i].value = data[i].id;
              data[i].label = data[i][displayKey];
              options.push(data[i]);
          }
        }
        this.setState({options: options});
      },
      error: (xhr, status, err) => {
      }
    });
  }

  handleChange = (e) => {
    let object = null;
    var properties = this.state.properties;
    var displayKey = properties.displayField || "name";
    if (properties.type === "select") {
      if (e && e.length !== 0) {
        if (typeof e.value === "string" && !e.id) {
          object = e.value;
        } else {
          object = e;
          object.id = e.value;
          object[displayKey] = e.label;
        }
      }
    } else if (properties.type === "multi") {
      object = e;
    }
    this.setState({object: object});
    this.props.onChange(this.props.objectKey, object);
  }

  componentWillReceiveProps = (props) => {
    if (typeof props.object === "undefined" || props.object === null) {
      return;
    }
    this.setInitialOptions(props);

    if (props.hostPropertyValue && (!this.props.hostPropertyValue || props.hostPropertyValue.id !== this.props.hostPropertyValue.id)) {
      this.updateHostedOptions(props);
    }
  }

  setInitialOptions = (props) => {
    var properties = this.state.properties;
    var displayKey = properties.displayField || "name";
    var state = {
      object: props.object,
      properties: props.properties,
    };
    if (props.object) {
      if (properties.type === "select") {
        if (typeof this.state.options === "undefined") {
          if (typeof object === "string") {
            state.options = [{value: state.object, label: state.object}];
          } else {
            state.options = [{value: state.object.id, label: state.object[displayKey]}];
          }
        }
        if (typeof state.object === "object") {
          state.object.value = state.object.id || state.object.value;
          state.object.label = state.object[displayKey] || state.object.label;
        }
      }

      if (properties.type === "multi") {
        if (typeof this.state.options === "undefined") {
          state.options = [];
          for (let i = 0; i < state.object.length; i++) {
            state.options.push({value: state.object[i].id, label: state.object[i][displayKey]});
          }
        }
        for (let i = 0; i < state.object.length; i++) {
          state.object[i].value = state.object[i].id || state.object[i].value;
          state.object[i].label = state.object[i][displayKey] || state.object[i].label;
        }
      }
    }
    if (props.object || props.properties) {
      this.setState(state);
    }
  }

  updateHostedOptions = (props) => {
    var properties = this.state.properties;
    if (properties.hostProperty) {
      let id = props.hostPropertyValue.id;
      if (!id) {
        if (this.state.object) {
          this.setState({object: null});
        }
        return;
      }
      sendRequest({
        method: properties.method.replace(":id", id),
        type: "GET",
        success: (data) => {
          let objectFound = !this.state.object || !this.state.object.id;
          let options = data.map((datum) => {
            if (this.state.object && this.state.object.id === datum.id) {
              objectFound = true;
            }
            datum.value = datum.id;
            datum.label = datum[properties.displayField || "name"];
            return datum;
          });
          let stateChange = {options: options};
          if (!objectFound) {
            stateChange.object = null;
          }
          this.setState(stateChange);
        }
      });
    }
  }

  handleItemClick = (val, e) => {
    var objectPageKey = this.state.properties.objectPageKey;
    if (objectPageKey && val.id) {
      $(document).trigger("openPage", [objectPageKey, {id: val.id}]);
    }
  }

  render = () => {
    var properties = this.state.properties;
    var value = this.state.object;
    if (properties.type !== "multi") {
      if (!value || (typeof value !== "string" && !value.id)) {
        value = null;
      }
    }
    return (
      <Select
        name="form-field-name"
        value={value}
        multi={properties.type === "multi"}
        clearable={properties.type === "select"}
        options={properties.options || this.state.options}
        onChange={this.handleChange}
        disabled={this.props.disabled}
        placeholder={properties.minSearch ? "Введите имя..." : "Выбрать..."}
        onValueClick={properties.objectPageKey ? this.handleItemClick : null}
        onInputChange={this.handleSelectInputChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/input/SelectInput.js